import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';
import Icon from '@loggi/ui/components/icon';
import { SHAPES, SQUARE_SHAPE } from '../types';
import styles from './styles.scss';

const cx = classNames.bind(styles);

class Image extends React.Component {
  static displayName = 'Image';

  static propTypes = {
    src: PropTypes.string,
    shape: PropTypes.oneOf(SHAPES),
    fluid: PropTypes.bool,
    iconTypeFallback: PropTypes.string,
    iconColorFallback: PropTypes.string,
    styleFallback: PropTypes.object,
    onLoad: PropTypes.func,
    onError: PropTypes.func,
    noBackgroundColor: PropTypes.bool
  };

  static defaultProps = {
    fluid: true,
    shape: SQUARE_SHAPE,
    iconTypeFallback: icons.type.LOGGI,
    iconColorFallback: colors.type.WHITE,
    styleFallback: null,
    noBackgroundColor: false
  };

  constructor(props) {
    super(props);

    this.state = {
      imageNotFound: false,
      imageLoaded: false
    };

    this._onImageError = this._onImageError.bind(this);
    this._onImageLoad = this._onImageLoad.bind(this);
  }

  _onImageError() {
    this.setState({ imageNotFound: true });

    if (this.props.onError) {
      this.props.onError();
    }
  }

  _onImageLoad() {
    this.setState({
      imageNotFound: false,
      imageLoaded: true
    });

    if (this.props.onLoad) {
      this.props.onLoad();
    }
  }

  render() {
    const {
      src,
      shape,
      fluid,
      iconTypeFallback,
      iconColorFallback,
      styleFallback,
      noBackgroundColor
    } = this.props;

    const { imageNotFound, imageLoaded } = this.state;
    const showImage = src && !imageNotFound;

    const imageClasses = [
      { ['loaded']: imageLoaded },
      { ['fluid']: fluid },
      { [`${shape}`]: shape },
      { ['img']: !noBackgroundColor }
    ];

    const placeholderClasses = [{ [`${shape}`]: shape }];

    if (!showImage && !imageLoaded) {
      return (
        <Icon
          className={cx(['iconPlaceholder'], placeholderClasses)}
          style={styleFallback}
          type={iconTypeFallback}
          color={iconColorFallback}
        />
      );
    }

    if (showImage) {
      return (
        <img
          src={src}
          className={cx(imageClasses)}
          onLoad={this._onImageLoad}
          onError={this._onImageError}
        />
      );
    }

    return null;
  }
}

export default Image;
